module.exports = require("././angular.js");


//////////////////
// WEBPACK FOOTER
// angular (bower component)
// module id = 1388
// module chunks = 1